import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArchive20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconArchive20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M16.5 6h-13v-.6a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1zM2 7.5h1v7A2.5 2.5 0 0 0 5.5 17h9a2.5 2.5 0 0 0 2.5-2.5v-7h1V5.4a2.5 2.5 0 0 0-2.5-2.5h-11A2.5 2.5 0 0 0 2 5.4zm2.5 0v7a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1v-7zM8.25 10a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconArchive20);
